import { render } from "./Icon.vue?vue&type=template&id=0ad18bbb&ts=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__